export const CVNA_ENV = process.env.CVNA_ENV || 'development';

export const CHAT_UI_SERVICE_NAME = 'ngcp-chat-ui';
